import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IAM_ACCOUNT_FEATURE_KEY, IAMAccountState } from "../reducers";

const iamAccountState = createFeatureSelector<IAMAccountState>(
  IAM_ACCOUNT_FEATURE_KEY
);

export const passwordUpdateIsLoading = createSelector(
  iamAccountState,
  (state: IAMAccountState) => state.passwordUpdateIsLoading
);

export const signInIsLoading = createSelector(
  iamAccountState,
  (state: IAMAccountState) => state.signInIsLoading
);
